import type { IndexedStep } from '@lqa-frontend/ui-system';
import { Icon } from '@lqa-frontend/ui-system';
import React from 'react';

export function StepCircleContent({ step }: { step: IndexedStep }) {
	switch (step.state) {
		case 'error':
			return <Icon name="exclamation" size="l" />;
		case 'completed':
			return <Icon name="checkLg" />;
		default:
			return step.index;
	}
}
